import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateSubstancesCompletion(
  patient: Patient | null | undefined,
) {
  const lifestyle = patient?.lifestyle;
  const hasAnswer =
    lifestyle?.hasAddictions !== undefined && lifestyle?.hasAddictions !== null;

  const addictions = lifestyle?.addictions;
  const hasDetails = lifestyle?.hasAddictions
    ? Array.isArray(addictions) && addictions.length > 0
    : lifestyle?.hasAddictions === false;

  const total = 2;
  const completed = (hasAnswer ? 1 : 0) + (hasDetails ? 1 : 0);
  const percent = total > 0 ? completed / total : 0;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
